import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { OSTypes } from "../../../Orchestrator/Types/Interface/IGetAppBanner";


class GetOSInfoAction extends BaseAction<OSTypes["osType"], string> {
  override async run(): Promise<OSTypes["osType"]> {
    try {
      const userAgent =
        navigator.userAgent ||
        (navigator as any).vendor ||
        (window as any).opera;

      let osType: OSTypes["osType"] = "Other";

      if (/android/i.test(userAgent)) {
        osType = "Android";
      } else if (
        /iPad|iPhone|iPod|Mac/.test(userAgent) &&
        !(window as any).MSStream
      ) {
        osType = "iOS";
      }

      updateRecoilState("selectOsInfo", osType);
      return osType;
    } catch (error: any) {
      console.error("Error detecting OS:", error);
      return "Other";
    }
  }
}

export const getOSInfoAction = new GetOSInfoAction();
